const FILTERS = [
  { id: "all", label: "All" },
  { id: "men", label: "Men" },
  { id: "women", label: "Women" },
  { id: "hats", label: "Hats" },
  { id: "steady-dose", label: "Steady Dose" },
];

const SHOP_COPY = {
  all: {
    kicker: "Shop",
    title: "All",
    hint: "Steady Dose plus everything on the live shop. Tap a piece. Swipe for the back.",
  },
  men: {
    kicker: "Shop",
    title: "Men",
    hint: "Men cut pieces, plus the shared layer.",
  },
  women: {
    kicker: "Shop",
    title: "Women",
    hint: "Women pieces, plus the shared layer.",
  },
  hats: {
    kicker: "Shop",
    title: "Hats",
    hint: "Caps and the visor.",
  },
  "steady-dose": {
    kicker: "Collection",
    title: "Steady Dose",
    hint: "Tap a piece. Hover for the back.",
  },
};

let catalog = [];
let filter = "steady-dose";
let pdpColor = 0;
let pdpSize = "";
let pdpQty = 1;
let pdpShots = [];
let pdpShotIndex = 0;
const cart = [];
const HOME_TITLE = "Zone Two | Daily output. Sustainable effort.";
const COLLECTION_TITLE = "The Steady Dose Collection";

function setTab(title) {
  document.title = title;
}

const shotViewer = {
  open: false,
  scale: 1,
  x: 0,
  y: 0,
  pointers: new Map(),
  pinch0: 0,
  pinchScale: 1,
  lastX: 0,
  lastY: 0,
  startX: 0,
  startY: 0,
  moved: false,
};

function money(n) {
  return `$${Number(n).toFixed(0)}`;
}

function fileStem(src) {
  return String(src || "")
    .split("?")[0]
    .split("/")
    .pop()
    .replace(/\.(png|jpe?g|webp)$/i, "");
}

function isShopifyCdn(src) {
  return /cdn\.shopify\.com|\/cdn\/shop\//.test(String(src || ""));
}

function mediaSrc(src, width) {
  if (!src) return "";
  if (isShopifyCdn(src)) {
    const url = new URL(src, location.origin);
    url.searchParams.set("width", String(width));
    return url.toString();
  }
  const stem = fileStem(src);
  if (!stem || stem.indexOf("zt-d-") === 0) return src;
  if (String(src).indexOf("assets/") === -1 && String(src).indexOf("/assets/") === -1) return src;
  return (window.ZT_ASSET_BASE || "") + "zt-d-" + stem + "-" + width + ".webp";
}

function imgHtml(src, alt, opts) {
  const priority = !!(opts && opts.priority);
  const thumb = !!(opts && opts.thumb);
  const safeAlt = String(alt || "").replace(/"/g, "&quot;");
  if (thumb) {
    return `<img src="${mediaSrc(src, 160)}" alt="${safeAlt}" width="160" height="160" loading="lazy" decoding="async">`;
  }
  let href;
  let srcset;
  if (isShopifyCdn(src)) {
    href = mediaSrc(src, 800);
    srcset = `${mediaSrc(src, 400)} 400w, ${href} 800w, ${mediaSrc(src, 1200)} 1200w`;
  } else {
    href = mediaSrc(src, 780);
    srcset = `${href} 780w, ${mediaSrc(src, 1170)} 1170w`;
  }
  const load = priority ? 'fetchpriority="high"' : 'loading="lazy"';
  const sizes = (opts && opts.sizes) || "100vw";
  return `<img src="${href}" srcset="${srcset}" sizes="${sizes}" alt="${safeAlt}" width="780" height="1000" ${load} decoding="async">`;
}

function matches(p, f) {
  if (p.hidden) return false;
  if (f === "all" || f === "shop") return true;
  if (f === "steady-dose") return p.collection === "steady-dose";
  if (f === "women") return p.gender === "women" || p.gender === "unisex";
  if (f === "men") return p.gender === "men" || p.gender === "unisex";
  if (f === "hats") return p.type === "Hats";
  return true;
}

function productShots(p) {
  const shots = [];
  p.colors.forEach((c, colorIndex) => {
    if (c.front) {
      shots.push({
        src: c.front,
        alt: `${p.title} ${c.name} front`,
        label: `${c.name} · front`,
        color: c.name,
        colorIndex,
      });
    }
    if (c.back) {
      shots.push({
        src: c.back,
        alt: `${p.title} ${c.name} back`,
        label: `${c.name} · back`,
        color: c.name,
        colorIndex,
      });
    }
    (c.shots || []).forEach((src, i) => {
      if (src === c.front || src === c.back) return;
      const file = String(src).split("?")[0].split("/").pop() || "";
      const kind = /-back/i.test(file)
        ? "back"
        : /-angle/i.test(file) || (!c.back && i === 0)
          ? "angle"
          : String(i + 1);
      shots.push({
        src,
        alt: `${p.title} ${c.name} ${kind}`,
        label: `${c.name} · ${kind}`,
        color: c.name,
        colorIndex,
      });
    });
  });
  return shots;
}

function firstShotForColor(shots, colorIndex) {
  const i = shots.findIndex((s) => s.colorIndex === colorIndex);
  return i < 0 ? 0 : i;
}

function card(p) {
  const color = p.colors[0] || {};
  const leadBack = p.handle === "hold-shorts" && color.back;
  const front = (leadBack ? color.back : color.front) || "";
  const hover = leadBack ? color.front : color.back || (color.shots || [])[0];
  const photo = p.collection === "core" ? " product--photo" : "";
  const back = hover ? imgHtml(hover, "", { sizes: "46vw" }).replace("<img ", '<img class="img-back" ') : "";
  return `<a class="product${photo}" href="#product/${p.handle}">
    <figure data-flip>
      ${imgHtml(front, p.title, { sizes: "46vw" })}
      ${back}
    </figure>
    <div class="product-meta">
      <span>${p.title}</span>
      <span class="price">${money(p.price)}</span>
    </div>
    <div class="product-type">${p.gender} · ${p.type}</div>
  </a>`;
}

function bindFlips(scope) {
  (scope || document).querySelectorAll("[data-flip]").forEach((el) => {
    if (el.dataset.flipBound) return;
    el.dataset.flipBound = "1";
    let x0 = 0;
    let y0 = 0;
    let swiped = false;
    el.addEventListener(
      "touchstart",
      (e) => {
        x0 = e.changedTouches[0].clientX;
        y0 = e.changedTouches[0].clientY;
        swiped = false;
      },
      { passive: true }
    );
    el.addEventListener(
      "touchend",
      (e) => {
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.15) {
          el.classList.toggle("is-back");
          swiped = true;
        }
      },
      { passive: true }
    );
    el.addEventListener("click", (e) => {
      if (!swiped) return;
      e.preventDefault();
      e.stopPropagation();
      swiped = false;
    });
  });
}

const SUB_JOINED_KEY = "zt_subscribed";
const SUB_CLOSED_KEY = "zt_sub_overlay_closed";
const SUB_CLOSED_MS = 7 * 24 * 60 * 60 * 1000;

function subStore(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function subJoined() {
  return Boolean(subStore(SUB_JOINED_KEY) || subStore("zt_subscribe_joined_v1"));
}

function subClosedRecently() {
  const raw = subStore(SUB_CLOSED_KEY);
  if (!raw) return false;
  const ts = parseInt(raw, 10);
  if (!ts) return true;
  return Date.now() - ts < SUB_CLOSED_MS;
}

function subBusy() {
  const path = (location.pathname || "/").replace(/\/$/, "") || "/";
  if (path === "/cart" || path.startsWith("/checkout")) return true;
  const sale = document.getElementById("sale-overlay");
  if (sale && !sale.hidden) return true;
  const bag = document.getElementById("cart-view");
  if ((bag && !bag.hidden) || document.body.classList.contains("zt-bag-open")) return true;
  const size = document.getElementById("size-overlay");
  if (size && !size.hidden) return true;
  const active = document.activeElement;
  if (active && active.closest && active.closest("#dock-size, #size-pills, .size-link, #size-overlay")) return true;
  return false;
}

function openSubscribe() {
  document.querySelectorAll(".drop-nav details").forEach((el) => {
    el.removeAttribute("open");
  });
  closeMenus();
  const overlay = document.getElementById("sub-overlay");
  if (!overlay || !overlay.hidden) return;
  overlay.hidden = false;
}

function closeSubscribe() {
  const overlay = document.getElementById("sub-overlay");
  if (overlay) overlay.hidden = true;
  try {
    localStorage.setItem(SUB_CLOSED_KEY, String(Date.now()));
  } catch (e) {}
}

function armSubscribePopup() {
  // 15% signup stays down through Mon Oct 12, 11:59 PM ET. Tuesday it arms again.
  if (Date.now() <= Date.parse("2026-10-13T03:59:00Z")) return;
  if (subJoined() || subClosedRecently()) return;
  const tryOpen = () => {
    if (subJoined() || subClosedRecently()) return;
    if (subBusy()) {
      window.setTimeout(tryOpen, 1000);
      return;
    }
    openSubscribe();
  };
  window.setTimeout(tryOpen, 5000);
}

function closeMenus() {
  document.querySelectorAll(".drop-nav details").forEach((el) => {
    el.removeAttribute("open");
  });
  const shop = document.querySelector(".nav-shop");
  const btn = shop?.querySelector(".nav-shop-btn");
  shop?.classList.remove("is-open");
  btn?.setAttribute("aria-expanded", "false");
}

function bindShopNav() {
  const shop = document.querySelector(".nav-desktop-shop");
  const btn = shop?.querySelector(".nav-shop-btn");
  if (!shop || !btn) return;
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const open = !shop.classList.contains("is-open");
    shop.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });
  document.addEventListener("click", (e) => {
    if (shop.contains(e.target)) return;
    shop.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
  });
}

function jumpTo(y) {
  const root = document.documentElement;
  const prev = root.style.scrollBehavior;
  root.style.scrollBehavior = "auto";
  window.scrollTo(0, y || 0);
  root.style.scrollBehavior = prev;
}

function hideViews(keepId) {
  document.body.classList.remove("zt-bag-open");
  if (keepId !== "pdp-view") document.body.classList.remove("is-pdp");
  document.querySelectorAll(".view").forEach((el) => {
    if (keepId && el.id === keepId) return;
    el.hidden = true;
  });
  const scrim = document.getElementById("zt-bag-scrim");
  if (scrim) scrim.hidden = true;
}

function shopChrome(on) {
  document.body.classList.toggle("is-shop", on);
}

function renderFilters() {
  const el = document.getElementById("filters");
  if (!el) return;
  el.innerHTML = FILTERS.map(
    (f) =>
      `<button type="button" data-filter="${f.id}" class="${
        filter === f.id ? "active" : ""
      }">${f.label}</button>`
  ).join("");
}

function renderShop(next) {
  const shop = document.getElementById("shop-wave");
  const already = shop && !shop.hidden;
  const y = window.scrollY;
  filter = FILTERS.some((f) => f.id === next) ? next : "all";
  hideViews();
  shopChrome(true);
  closeMenus();
  const copy = SHOP_COPY[filter] || SHOP_COPY.all;
  document.getElementById("wave-kicker").textContent = copy.kicker;
  document.getElementById("wave-title").textContent = copy.title;
  document.getElementById("wave-hint").textContent = copy.hint;
  renderFilters();
  const list = catalog.filter((p) => matches(p, filter));
  const grid = document.getElementById("wave-grid");
  grid.innerHTML = list.map(card).join("");
  bindFlips(grid);
  setTab(filter === "steady-dose" ? COLLECTION_TITLE : HOME_TITLE);
  shop.hidden = false;
  jumpTo(already ? y : 0);
}

let pdpFrameWidth = 0;
let pdpFrameHeight = 0;

function fitPdpFrame() {
  // Photo, breadcrumb, and dock are sized in the first HTML. Resizing after paint shifts the page.
}

function showHome() {
  const home = document.getElementById("home-steady");
  if (!home) {
    location.assign("/");
    return;
  }
  hideViews();
  shopChrome(false);
  closeMenus();
  home.hidden = false;
  setTab(HOME_TITLE);
}

function showShipping() {
  hideViews();
  shopChrome(true);
  closeMenus();
  const el = document.getElementById("shipping-view");
  if (el) el.hidden = false;
  setTab("Shipping");
  jumpTo(0);
}

function hasSizeGuide(p) {
  return !!(p && (p.sizeGuide || (p.sizes || []).length > 1));
}

function sizeTable(p) {
  if (!p.sizeGuide) return "";
  const cols = p.sizeGuide.columns;
  const sizes = p.sizes || Object.keys(p.sizeGuide.rows);
  const head = ["Size", ...cols].map((c) => `<th>${c}</th>`).join("");
  const body = sizes
    .map((size) => {
      const row = p.sizeGuide.rows[size] || [];
      return `<tr><th>${size}</th>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`;
    })
    .join("");
  return `
    <table>
      <thead><tr>${head}</tr></thead>
      <tbody>${body}</tbody>
    </table>
    <p class="size-note">${p.sizeNote || ""}</p>
  `;
}

function sizeList(p) {
  const sizes = [...(p.sizes || [])];
  const letters = ["S", "M", "L", "XL", "2XL"];
  if (sizes.some((s) => letters.includes(s)) && !sizes.includes("S")) sizes.unshift("S");
  return sizes;
}

function sizeGone(p, size) {
  if (!(p.sizes || []).includes(size)) return true;
  const gone = {
    "capsule-tank": { Charcoal: ["XL"] },
    "yin-tank": { Black: ["XL"] },
  };
  const color = (p.colors || [])[pdpColor];
  const sizes = gone[p.handle] && color && gone[p.handle][color.name];
  return Array.isArray(sizes) && sizes.includes(size);
}

function sizePill(p, s) {
  const out = sizeGone(p, s);
  if (out) {
    return `<button type="button" class="pill is-out" data-size="${s}" disabled aria-label="${s} sold out">${s}</button>`;
  }
  return `<button type="button" class="pill${s === pdpSize ? " active" : ""}" data-size="${s}">${s}</button>`;
}

function sizeOption(p, s) {
  const out = sizeGone(p, s);
  if (out) return `<option value="${s}" disabled>${s}</option>`;
  return `<option value="${s}"${s === pdpSize ? " selected" : ""}>${s}</option>`;
}

function renderPdp(handle, colorIndex = 0) {
  const p = catalog.find((x) => x.handle === handle);
  if (!p) {
    location.hash = "shop";
    return;
  }
  jumpTo(0);
  pdpColor = Math.min(Math.max(0, colorIndex), p.colors.length - 1);
  if (!pdpSize || !sizeList(p).includes(pdpSize) || sizeGone(p, pdpSize)) pdpSize = "";
  if (!pdpSize && sizeList(p).length === 1 && !sizeGone(p, sizeList(p)[0])) pdpSize = sizeList(p)[0];
  const color = p.colors[pdpColor];

  const el = document.getElementById("pdp-view");
  const ssr = el.dataset.handle === handle && el.querySelector(".pdp-crumb") && el.querySelector(".pdp-dock") && document.getElementById("zt-lcp");
  const keepFirst = el.dataset.handle === handle && document.getElementById("zt-lcp");
  const firstHtml = keepFirst ? document.getElementById("zt-lcp").outerHTML : "";

  pdpShots = productShots(p);
  pdpShotIndex = firstShotForColor(pdpShots, pdpColor);
  setTab(`${p.title} | Zone Two`);

  if (ssr) {
    const slideCount = document.querySelectorAll("#pdp-track .pdp-slide").length;
    while (pdpShots.length < slideCount) {
      pdpShots.push({
        src: "",
        alt: p.title,
        label: String(pdpShots.length + 1),
        color: color.name,
        colorIndex: pdpColor,
      });
    }
    hideViews("pdp-view");
    shopChrome(true);
    closeMenus();
    closeShotViewer();
    el.hidden = false;
    document.body.classList.add("is-pdp");
    bindPdpGallery();
    const sizeLabel = document.getElementById("dock-size")?.closest(".dock-select")?.querySelector(".dock-select-label");
    if (sizeLabel && hasSizeGuide(p) && !sizeLabel.querySelector("[data-open-size]")) {
      sizeLabel.innerHTML = '<span>Size</span><button type="button" class="size-link" data-open-size>Size guide</button>';
    }
    const sizeAnchor = el.querySelector(".pdp-buy > .option-row") || el.querySelector(".pdp-dock");
    if (sizeAnchor && sizeList(p).length > 1 && !document.getElementById("size-pills")) {
      sizeAnchor.insertAdjacentHTML(
        "afterend",
        `<div class="option-row"><div class="option-legend"><span>Size</span>${
          hasSizeGuide(p) ? `<button type="button" class="size-link" data-open-size>Size guide</button>` : ""
        }</div><div class="pills" id="size-pills">${sizeList(p).map((s) => sizePill(p, s)).join("")}</div></div>`
      );
    }
    const dockSize = document.getElementById("dock-size");
    if (dockSize) {
      dockSize.innerHTML = `${
        sizeList(p).length === 1 ? "" : `<option value=""${pdpSize ? "" : " selected"} disabled>Select</option>`
      }${sizeList(p).map((s) => sizeOption(p, s)).join("")}`;
    }
    document.getElementById("dock-color")?.addEventListener("change", (e) => {
      showColor(Number(e.target.value));
      const next = `#product/${p.handle}/${e.target.value}`;
      if (location.hash !== next) history.replaceState(null, "", next);
    });
    document.getElementById("dock-size")?.addEventListener("change", (e) => {
      pdpSize = e.target.value;
      clearSizeNote();
    });
    return;
  }

  const html = `
    <p class="pdp-crumb"><a href="#shop">Shop</a> / ${p.title}</p>
    <article class="pdp-page">
      <div class="pdp-gallery${p.collection === "core" ? " pdp-gallery--photo" : ""}">
        <div class="pdp-media">
          <div class="pdp-track" id="pdp-track">
            ${pdpShots
              .map(
                (s, i) =>
                  `<figure class="pdp-slide" data-open-shot="${i}">
                    ${i === 0 && firstHtml ? firstHtml : imgHtml(s.src, s.alt, { priority: i === 0 })}
                  </figure>`
              )
              .join("")}
          </div>
          ${
            pdpShots.length > 1
              ? `<button type="button" class="pdp-arrow prev" data-gallery-step="-1" aria-label="Previous image">‹</button>
                 <button type="button" class="pdp-arrow next" data-gallery-step="1" aria-label="Next image">›</button>`
              : ""
          }
        </div>
        <div class="pdp-thumbs" id="pdp-thumbs">
          ${pdpShots
            .map(
              (s, i) =>
                `<button type="button" data-goto-shot="${i}" class="${
                  i === pdpShotIndex ? "active" : ""
                }" aria-label="${s.label}">
                  ${imgHtml(s.src, "", { thumb: true })}
                </button>`
            )
            .join("")}
        </div>
        <p class="pdp-shot-hint">${pdpShots.length} images · swipe · tap to enlarge</p>
      </div>
      <div class="pdp-buy">
        <p class="pdp-kicker">${p.gender} · ${p.type}</p>
        <h1>${p.title}</h1>
        <p class="pdp-price">${money(p.price)}</p>
        <p class="pdp-ship">Free US shipping on orders $70+.</p>

        <div class="option-row">
          <div class="option-legend">
            <span>Color: ${color.name}</span>
          </div>
          <div class="pills">
            ${p.colors
              .map(
                (c, i) =>
                  `<a class="pill${i === pdpColor ? " active" : ""}" href="#product/${p.handle}/${i}">${c.name}</a>`
              )
              .join("")}
          </div>
        </div>

        <div class="option-row">
          <div class="option-legend">
            <span>Size${pdpSize ? `: ${pdpSize}` : ""}</span>
            ${hasSizeGuide(p) ? `<button type="button" class="size-link" data-open-size>Size guide</button>` : ""}
          </div>
          <div class="pills" id="size-pills">
            ${sizeList(p).map((s) => sizePill(p, s)).join("")}
          </div>
        </div>

        <div class="option-row qty-row">
          <span class="option-legend"><span>Quantity</span></span>
          <div class="qty">
            <button type="button" data-qty="-1">−</button>
            <span id="qty-val">${pdpQty}</span>
            <button type="button" data-qty="1">+</button>
          </div>
        </div>

        <div class="pdp-dock">
          <div class="dock-fields">
            <div class="dock-select">
              <span class="dock-select-label">Color</span>
              <select id="dock-color" aria-label="Color">
                ${p.colors
                  .map(
                    (c, i) =>
                      `<option value="${i}"${i === pdpColor ? " selected" : ""}>${c.name}</option>`
                  )
                  .join("")}
              </select>
            </div>
            <div class="dock-select">
              <span class="dock-select-label">
                <span>Size</span>
                ${hasSizeGuide(p) ? `<button type="button" class="size-link" data-open-size>Size guide</button>` : ""}
              </span>
              <select id="dock-size" aria-label="Size">
                ${sizeList(p).length === 1 ? "" : `<option value=""${pdpSize ? "" : " selected"} disabled>Select</option>`}
                ${sizeList(p).map((s) => sizeOption(p, s)).join("")}
              </select>
            </div>
          </div>
      <button type="button" class="add-btn" data-add>
        <span class="dock-price">${money(p.price)}</span>
        <span>Add to bag</span>
      </button>
      <button type="button" class="pdp-checkout" data-checkout>Checkout</button>
      <p class="add-note" id="add-note" hidden></p>
        </div>

        <div class="pdp-desc">
          <p class="pdp-lead">${p.lead}</p>
          <p>${p.description}</p>
          <p class="material-line"><strong>Material</strong> ${p.fabric}</p>
          <ul class="pdp-details">${(p.details || []).map((d) => `<li>${d}</li>`).join("")}</ul>
        </div>
      </div>
    </article>
  `;
  hideViews("pdp-view");
  shopChrome(true);
  closeMenus();
  closeShotViewer();
  el.innerHTML = html;
  el.hidden = false;
  el.dataset.handle = handle;
  document.body.classList.add("is-pdp");
  bindPdpGallery();
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      jumpTo(0);
      fitPdpFrame();
    })
  );
  document.getElementById("dock-color")?.addEventListener("change", (e) => {
    showColor(Number(e.target.value));
    const next = `#product/${p.handle}/${e.target.value}`;
    if (location.hash !== next) history.replaceState(null, "", next);
  });
  document.getElementById("dock-size")?.addEventListener("change", (e) => {
    pdpSize = e.target.value;
    document.querySelectorAll("#size-pills .pill").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.size === pdpSize);
    });
    const legend = document.querySelectorAll(".pdp-buy .option-row .option-legend span")[1];
    if (legend) legend.textContent = `Size: ${pdpSize}`;
    clearSizeNote();
  });
  jumpTo(0);
}

function paintShotIndex(index) {
  pdpShotIndex = Math.min(Math.max(0, index), Math.max(0, pdpShots.length - 1));
  const shot = pdpShots[pdpShotIndex];
  if (!shot) return;

  document.querySelectorAll("#pdp-thumbs [data-goto-shot]").forEach((btn) => {
    btn.classList.toggle("active", Number(btn.dataset.gotoShot) === pdpShotIndex);
  });

  if (shot.colorIndex !== pdpColor) {
    pdpColor = shot.colorIndex;
    const handle = document.getElementById("pdp-view").dataset.handle;
    document.querySelectorAll(".pdp-buy .pills a.pill").forEach((a, i) => {
      a.classList.toggle("active", i === pdpColor);
    });
    const legend = document.querySelector(".pdp-buy .option-row .option-legend span");
    const dockColor = document.getElementById("dock-color");
    if (legend && handle) {
      const p = catalog.find((x) => x.handle === handle);
      if (p) legend.textContent = `Color: ${p.colors[pdpColor].name}`;
    }
    if (dockColor) dockColor.value = String(pdpColor);
  }
}

let galleryPinUntil = 0;
let galleryPinIndex = 0;

function scrollPdpTo(index, instant = false) {
  const track = document.getElementById("pdp-track");
  if (!track || !pdpShots.length) return;
  const target = Math.min(Math.max(0, index), pdpShots.length - 1);
  const place = () => {
    const w = track.clientWidth;
    if (!w) return false;
    paintShotIndex(target);
    if (instant) {
      galleryPinUntil = 0;
      track.style.scrollSnapType = "none";
      track.style.scrollBehavior = "auto";
      track.scrollLeft = target * w;
      track.style.scrollSnapType = "";
      track.style.scrollBehavior = "";
      return true;
    }
    galleryPinIndex = target;
    galleryPinUntil = performance.now() + 400;
    track.scrollTo({ left: target * w, behavior: "smooth" });
    return true;
  };
  if (!place()) requestAnimationFrame(place);
}

function showColor(colorIndex) {
  const handle = document.getElementById("pdp-view")?.dataset.handle;
  const p = catalog.find((x) => x.handle === handle);
  if (!p || !pdpShots.length) return;
  pdpColor = Math.min(Math.max(0, colorIndex), p.colors.length - 1);
  document.querySelectorAll(".pdp-buy .pills a.pill").forEach((a, i) => {
    a.classList.toggle("active", i === pdpColor);
  });
  const legend = document.querySelector(".pdp-buy .option-row .option-legend span");
  if (legend) legend.textContent = `Color: ${p.colors[pdpColor].name}`;
  const dockColor = document.getElementById("dock-color");
  if (dockColor) dockColor.value = String(pdpColor);
  if (pdpSize && sizeGone(p, pdpSize)) pdpSize = "";
  const sizeRow = document.getElementById("size-pills");
  if (sizeRow) sizeRow.innerHTML = sizeList(p).map((s) => sizePill(p, s)).join("");
  const sizeLegend = sizeRow?.closest(".option-row")?.querySelector(".option-legend span");
  if (sizeLegend) sizeLegend.textContent = `Size${pdpSize ? `: ${pdpSize}` : ""}`;
  const dockSize = document.getElementById("dock-size");
  if (dockSize) {
    dockSize.innerHTML = `${
      sizeList(p).length === 1 ? "" : `<option value=""${pdpSize ? "" : " selected"} disabled>Select</option>`
    }${sizeList(p).map((s) => sizeOption(p, s)).join("")}`;
  }
  scrollPdpTo(firstShotForColor(pdpShots, pdpColor), true);
}

function lockPdpPhoto() {
  const media = document.querySelector("body.is-pdp .pdp-page .pdp-media");
  if (!media || media.dataset.ztLock) return;
  if (!window.matchMedia("(max-width: 820px)").matches) return;
  const h = Math.round(media.getBoundingClientRect().height);
  if (h < 40) return;
  media.style.height = h + "px";
  media.style.minHeight = h + "px";
  media.style.maxHeight = h + "px";
  media.dataset.ztLock = "1";
}

function bindPdpGallery() {
  const track = document.getElementById("pdp-track");
  if (!track) return;
  lockPdpPhoto();

  const syncFromScroll = () => {
    const w = track.clientWidth || 1;
    paintShotIndex(Math.round(track.scrollLeft / w));
  };
  track.addEventListener("scroll", syncFromScroll, { passive: true });
  if (!track.dataset.gotoBound) {
    track.dataset.gotoBound = "1";
    document.getElementById("pdp-view")?.addEventListener("pointerup", (e) => {
      const goto = e.target.closest("[data-goto-shot]");
      if (!goto) return;
      scrollPdpTo(Number(goto.dataset.gotoShot));
    });
  }

  let downX = 0;
  let downY = 0;
  track.addEventListener(
    "pointerdown",
    (e) => {
      downX = e.clientX;
      downY = e.clientY;
    },
    { passive: true }
  );
  track.addEventListener("click", (e) => {
    if (Math.hypot(e.clientX - downX, e.clientY - downY) > 12) return;
    const slide = e.target.closest("[data-open-shot]");
    if (!slide) return;
    openShotViewer(Number(slide.dataset.openShot));
  });

  requestAnimationFrame(() => {
    const w = track.clientWidth || 1;
    if (track.scrollLeft > 2) {
      paintShotIndex(Math.round(track.scrollLeft / w));
      return;
    }
    scrollPdpTo(pdpShotIndex, true);
  });
}

function resetShotZoom() {
  shotViewer.scale = 1;
  shotViewer.x = 0;
  shotViewer.y = 0;
  applyShotZoom();
}

function shotFit() {
  const img = document.getElementById("shot-img");
  const stage = document.getElementById("shot-stage");
  if (!img || !stage || !img.naturalWidth) return 1;
  return Math.min(stage.clientWidth / img.naturalWidth, stage.clientHeight / img.naturalHeight);
}

function applyShotZoom() {
  const img = document.getElementById("shot-img");
  const stage = document.getElementById("shot-stage");
  if (!img || !stage || !img.naturalWidth) return;
  img.style.width = `${img.naturalWidth}px`;
  img.style.height = `${img.naturalHeight}px`;
  const s = shotFit() * shotViewer.scale;
  img.style.transform = `translate(calc(-50% + ${shotViewer.x}px), calc(-50% + ${shotViewer.y}px)) scale(${s})`;
  stage.classList.toggle("is-zoomed", shotViewer.scale > 1);
}

function zoomAt(clientX, clientY, nextScale) {
  const stage = document.getElementById("shot-stage");
  if (!stage) return;
  const rect = stage.getBoundingClientRect();
  const cx = clientX - rect.left - rect.width / 2;
  const cy = clientY - rect.top - rect.height / 2;
  const prev = shotViewer.scale || 1;
  const next = Math.min(3, Math.max(1, nextScale));
  if (next === 1) {
    resetShotZoom();
    return;
  }
  shotViewer.x = cx - ((cx - shotViewer.x) * next) / prev;
  shotViewer.y = cy - ((cy - shotViewer.y) * next) / prev;
  shotViewer.scale = next;
  applyShotZoom();
}

function paintShotViewer() {
  const shot = pdpShots[pdpShotIndex];
  const img = document.getElementById("shot-img");
  const meta = document.getElementById("shot-meta");
  const count = document.getElementById("shot-count");
  const thumbs = document.getElementById("shot-thumbs");
  if (!shot || !img) return;
  img.onload = () => {
    resetShotZoom();
  };
  img.src = mediaSrc(shot.src, isShopifyCdn(shot.src) ? 1200 : 1170);
  img.alt = shot.alt;
  if (img.complete && img.naturalWidth) resetShotZoom();
  if (meta) meta.textContent = shot.label;
  if (count) count.textContent = `${pdpShotIndex + 1} / ${pdpShots.length}`;
  if (thumbs) {
    thumbs.innerHTML = pdpShots
      .map(
        (s, i) =>
          `<button type="button" data-shot-goto="${i}" class="${
            i === pdpShotIndex ? "active" : ""
          }" aria-label="${s.label}">${imgHtml(s.src, "", { thumb: true })}</button>`
      )
      .join("");
  }
}

function openShotViewer(index) {
  if (!pdpShots.length) return;
  paintShotIndex(index);
  paintShotViewer();
  const overlay = document.getElementById("shot-overlay");
  overlay.hidden = false;
  shotViewer.open = true;
  document.body.classList.add("shot-open");
}

function closeShotViewer() {
  const overlay = document.getElementById("shot-overlay");
  if (overlay) overlay.hidden = true;
  shotViewer.open = false;
  shotViewer.pointers.clear();
  document.body.classList.remove("shot-open");
  resetShotZoom();
  const track = document.getElementById("pdp-track");
  if (track) scrollPdpTo(pdpShotIndex, "instant");
}

function stepShot(delta) {
  if (!pdpShots.length) return;
  paintShotIndex((pdpShotIndex + delta + pdpShots.length) % pdpShots.length);
  if (shotViewer.open) paintShotViewer();
  else scrollPdpTo(pdpShotIndex);
}

function bindShotViewer() {
  const overlay = document.getElementById("shot-overlay");
  const stage = document.getElementById("shot-stage");
  if (!overlay || !stage) return;

  overlay.addEventListener("click", (e) => {
    if (e.target.closest("[data-close-shot]")) {
      closeShotViewer();
      return;
    }
    const step = e.target.closest("[data-shot-step]");
    if (step) {
      stepShot(Number(step.dataset.shotStep));
      return;
    }
    const thumb = e.target.closest("[data-shot-goto]");
    if (thumb) {
      paintShotIndex(Number(thumb.dataset.shotGoto));
      paintShotViewer();
    }
  });

  stage.addEventListener("pointerdown", (e) => {
    stage.setPointerCapture(e.pointerId);
    shotViewer.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    shotViewer.lastX = e.clientX;
    shotViewer.lastY = e.clientY;
    shotViewer.startX = e.clientX;
    shotViewer.startY = e.clientY;
    shotViewer.moved = false;
    if (shotViewer.pointers.size === 2) {
      const [a, b] = [...shotViewer.pointers.values()];
      shotViewer.pinch0 = Math.hypot(a.x - b.x, a.y - b.y) || 1;
      shotViewer.pinchScale = shotViewer.scale;
    }
  });

  stage.addEventListener("pointermove", (e) => {
    if (!shotViewer.pointers.has(e.pointerId)) return;
    shotViewer.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (shotViewer.pointers.size === 2) {
      const [a, b] = [...shotViewer.pointers.values()];
      const dist = Math.hypot(a.x - b.x, a.y - b.y) || 1;
      const midX = (a.x + b.x) / 2;
      const midY = (a.y + b.y) / 2;
      shotViewer.moved = true;
      zoomAt(midX, midY, shotViewer.pinchScale * (dist / shotViewer.pinch0));
      return;
    }

    const dx = e.clientX - shotViewer.lastX;
    const dy = e.clientY - shotViewer.lastY;
    shotViewer.lastX = e.clientX;
    shotViewer.lastY = e.clientY;
    if (Math.hypot(e.clientX - shotViewer.startX, e.clientY - shotViewer.startY) > 8) {
      shotViewer.moved = true;
    }
    if (shotViewer.scale > 1) {
      shotViewer.x += dx;
      shotViewer.y += dy;
      applyShotZoom();
    }
  });

  const endPointer = (e) => {
    shotViewer.pointers.delete(e.pointerId);
    if (shotViewer.pointers.size) return;
    if (!shotViewer.moved) {
      if (shotViewer.scale > 1) resetShotZoom();
      else zoomAt(e.clientX, e.clientY, 2.2);
      return;
    }
    if (shotViewer.scale === 1) {
      const dx = e.clientX - shotViewer.startX;
      const dy = e.clientY - shotViewer.startY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
        stepShot(dx < 0 ? 1 : -1);
      }
    }
  };
  stage.addEventListener("pointerup", endPointer);
  stage.addEventListener("pointercancel", endPointer);

  stage.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      zoomAt(e.clientX, e.clientY, shotViewer.scale * (e.deltaY < 0 ? 1.14 : 0.86));
    },
    { passive: false }
  );

  stage.addEventListener(
    "gesturestart",
    (e) => {
      e.preventDefault();
      shotViewer.pinchScale = shotViewer.scale;
    },
    { passive: false }
  );
  stage.addEventListener(
    "gesturechange",
    (e) => {
      e.preventDefault();
      zoomAt(e.clientX, e.clientY, shotViewer.pinchScale * e.scale);
    },
    { passive: false }
  );

  window.addEventListener("resize", () => {
    if (shotViewer.open) applyShotZoom();
  });
}

function renderCart() {
  setTab("Bag | Zone Two");
  hideViews();
  shopChrome(true);
  closeMenus();
  document.getElementById("cart-view").hidden = false;
  const empty = document.getElementById("cart-empty");
  const list = document.getElementById("cart-items");
  if (!cart.length) {
    empty.hidden = false;
    list.innerHTML = "";
    jumpTo(0);
    return;
  }
  empty.hidden = true;
  list.innerHTML = `
    <ul class="cart-list">
      ${cart
        .map(
          (item) =>
            `<li><strong>${item.title}</strong> · ${item.color} · ${item.size} · qty ${item.qty} · ${money(item.price * item.qty)}</li>`
        )
        .join("")}
    </ul>
  `;
  jumpTo(0);
}

function updateCartCount() {
  const n = cart.reduce((sum, item) => sum + item.qty, 0);
  const el = document.getElementById("cart-count");
  if (el) el.textContent = String(n);
}

function openSizeGuide() {
  const handle = document.getElementById("pdp-view").dataset.handle;
  const p = catalog.find((x) => x.handle === handle);
  if (!p) return;
  const body = document.getElementById("size-modal-body");
  body.innerHTML = `
    <div class="size-modal-head">
      <h2 id="size-modal-title">Size guide</h2>
      <button type="button" class="size-modal-close" data-close-size>(x)</button>
    </div>
    <p class="fit-line"><span>Fit</span> ${p.fit}</p>
    ${sizeTable(p)}
    ${handle === "quiet-mock" || handle === "dose-tee" ? "" : `<p class="size-note">Between sizes? Size up for layers. Size true for a closer fit.</p>`}
  `;
  document.getElementById("size-overlay").hidden = false;
}

function closeSizeGuide() {
  const el = document.getElementById("size-overlay");
  if (el) el.hidden = true;
}

function clearSizeNote() {
  const note = document.getElementById("add-note");
  if (note && /pick a size/i.test(note.textContent)) note.hidden = true;
}

function route() {
  const raw = (location.hash || "#top").replace(/^#/, "");
  const [page, handle, color] = raw.split("/");
  pdpQty = page === "product" ? pdpQty : 1;

  if (page === "product" && handle) {
    const product = catalog.find((x) => x.handle === handle);
    if (!product || product.hidden) {
      renderShop("all");
      return;
    }
    const view = document.getElementById("pdp-view");
    const same = view && !view.hidden && view.dataset.handle === handle && pdpShots.length;
    if (same) showColor(Number(color || 0));
    else renderPdp(handle, Number(color || 0));
  } else {
    pdpSize = "";
    if (page === "cart") {
      renderCart();
    } else if (page === "subscribe") {
      openSubscribe();
    } else if (page === "men" || page === "women" || page === "hats") {
      renderShop(page);
    } else if (page === "collection" || page === "steady-dose") {
      renderShop("steady-dose");
    } else if (page === "shop" || page === "all" || page === "shop-wave") {
      renderShop("all");
    } else if (page === "shipping") {
      showShipping();
    } else {
      showHome();
    }
  }

  const previewNav = new URLSearchParams(location.search).get("nav");
  if (previewNav === "shop") {
    queueMicrotask(() => {
      const shop = document.querySelector(".nav-shop");
      const btn = shop?.querySelector(".nav-shop-btn");
      shop?.classList.add("is-open");
      btn?.setAttribute("aria-expanded", "true");
    });
  }
  if (previewNav === "menu") {
    queueMicrotask(() => {
      document.querySelector(".nav-more")?.setAttribute("open", "");
    });
  }
  if (previewNav === "footer") {
    queueMicrotask(() => {
      document.querySelector(".site-footer")?.scrollIntoView({ behavior: "auto" });
    });
  }
}

function lockHeroSize() {
  const screen = document.querySelector(".hero-screen");
  if (!screen) return;

  const apply = () => {
    screen.style.height = "";
    screen.style.minHeight = "";
    screen.style.maxHeight = "";
    if (!window.matchMedia("(max-width: 820px)").matches) return;
    const vh = window.visualViewport?.height || window.innerHeight;
    if (vh <= 0) return;
    const px = `${Math.round(vh)}px`;
    screen.style.height = px;
    screen.style.minHeight = px;
    screen.style.maxHeight = px;
  };

  apply();
  window.addEventListener("orientationchange", () => {
    requestAnimationFrame(() => requestAnimationFrame(apply));
  });
}

function startMarquee() {
  const track = document.querySelector(".marquee-lite__track");
  const seq = track?.querySelector(".marquee-lite__seq");
  if (!track || !seq || track.dataset.marqueeOn) return;
  track.dataset.marqueeOn = "1";
  track.style.animation = "none";

  let width = 0;
  let origin = 0;
  const measure = () => {
    const next = seq.getBoundingClientRect().width;
    if (next > 8) width = next;
  };
  const frame = (now) => {
    if (!origin) origin = now;
    if (!width) measure();
    if (width) {
      const duration = Math.max(12000, (width / 72) * 1000);
      const dist = (((now - origin) % duration) / duration) * width;
      track.style.transform = `translate3d(${-dist}px, 0, 0)`;
    }
    requestAnimationFrame(frame);
  };

  measure();
  requestAnimationFrame(frame);
  document.fonts?.ready?.then(measure);
  window.addEventListener("resize", measure);
  window.visualViewport?.addEventListener("resize", measure);
}

lockHeroSize();
startMarquee();
lockPdpPhoto();

async function main() {
  const data = await fetch(window.ZT_CATALOG || "catalog.json").then((r) => r.json());
  catalog = data.products || [];

  bindFlips(document.querySelector(".trio"));
  bindShotViewer();

  document.getElementById("filters")?.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-filter]");
    if (!btn) return;
    const id = btn.dataset.filter;
    location.hash = id === "all" ? "shop" : id;
  });

  document.getElementById("pdp-view").addEventListener("click", (e) => {
    const goto = e.target.closest("[data-goto-shot]");
    if (goto) {
      scrollPdpTo(Number(goto.dataset.gotoShot));
      return;
    }
    const step = e.target.closest("[data-gallery-step]");
    if (step) {
      stepShot(Number(step.dataset.galleryStep));
      return;
    }
    const sizeBtn = e.target.closest("[data-size]");
    if (sizeBtn) {
      if (sizeBtn.disabled || sizeBtn.classList.contains("is-out")) return;
      pdpSize = sizeBtn.dataset.size;
      document.querySelectorAll("#size-pills .pill").forEach((btn) => {
        btn.classList.toggle("active", btn.dataset.size === pdpSize);
      });
      const dockSize = document.getElementById("dock-size");
      if (dockSize) dockSize.value = pdpSize;
      const legend = document.querySelectorAll(".pdp-buy .option-row .option-legend span")[1];
      if (legend) legend.textContent = `Size: ${pdpSize}`;
      clearSizeNote();
      return;
    }
    if (e.target.closest("[data-open-size]")) {
      openSizeGuide();
      return;
    }
    const qtyBtn = e.target.closest("[data-qty]");
    if (qtyBtn) {
      pdpQty = Math.max(1, pdpQty + Number(qtyBtn.dataset.qty));
      const val = document.getElementById("qty-val");
      if (val) val.textContent = String(pdpQty);
      return;
    }
    if (e.target.closest("[data-checkout]")) {
      e.preventDefault();
      const note = document.getElementById("add-note");
      if (!pdpSize) {
        if (note) {
          note.hidden = false;
          note.textContent = "Pick a size first.";
        }
        return;
      }
      return;
    }
    if (e.target.closest("[data-add]")) {
      const handle = document.getElementById("pdp-view").dataset.handle;
      const p = catalog.find((x) => x.handle === handle);
      const note = document.getElementById("add-note");
      if (!pdpSize) {
        if (note) note.textContent = "Pick a size first.";
        return;
      }
      if (sizeGone(p, pdpSize)) {
        if (note) note.textContent = "That size is gone.";
        return;
      }
      cart.push({
        handle: p.handle,
        title: p.title,
        color: p.colors[pdpColor].name,
        size: pdpSize,
        qty: pdpQty,
        price: p.price,
      });
      updateCartCount();
      if (note) note.textContent = `Added ${p.title} · ${p.colors[pdpColor].name} · ${pdpSize}. Preview bag only.`;
    }
  });

  document.getElementById("size-overlay").addEventListener("click", (e) => {
    if (e.target.id === "size-overlay" || e.target.closest("[data-close-size]")) {
      closeSizeGuide();
    }
  });

  document.body.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-subscribe]")) {
      e.preventDefault();
      openSubscribe();
      return;
    }
    if (e.target.closest("[data-close-subscribe]") || e.target.id === "sub-overlay") {
      e.preventDefault();
      closeSubscribe();
    }
  });

  document.getElementById("sub-form")?.addEventListener("submit", (e) => {
    e.preventDefault();
  });
  const subNote = document.getElementById("sub-note");
  if (subNote) {
    new MutationObserver(() => {
      if (/you're in/i.test(subNote.textContent || "")) {
        try {
          localStorage.setItem(SUB_JOINED_KEY, "1");
        } catch (err) {}
      }
    }).observe(subNote, { childList: true, characterData: true, subtree: true });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const sale = document.getElementById("sale-overlay");
      if (sale && !sale.hidden && typeof window.ztCloseSale === "function") {
        window.ztCloseSale();
        return;
      }
      if (shotViewer.open) {
        closeShotViewer();
        return;
      }
      closeSizeGuide();
      closeMenus();
      const overlay = document.getElementById("sub-overlay");
      if (overlay && !overlay.hidden) {
        overlay.hidden = true;
        document.body.classList.remove("shot-open");
      }
      return;
    }
    if (!shotViewer.open) return;
    if (e.key === "ArrowLeft") stepShot(-1);
    if (e.key === "ArrowRight") stepShot(1);
  });

  bindShopNav();
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href^='#']");
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const href = a.getAttribute("href") || "";
      if (!/^#(product\/|shop|men|women|hats|collection|steady-dose|cart|shipping|top|all)/.test(href)) return;
      e.preventDefault();
      document.documentElement.style.scrollBehavior = "auto";
      jumpTo(0);
      if (location.hash !== href) location.hash = href;
      else route();
    },
    true
  );
  window.addEventListener("hashchange", route);
  window.addEventListener("resize", fitPdpFrame);
  route();
}

main();
armSubscribePopup();
